export enum Routes {
  ENTRY_POINT_INDEX = 'entry-point.index',
  ENTRY_POINT_LOGOUT = 'entry-point.logout',

  LOGIN_INDEX = 'login.index',
  LOGIN_TWO_FACTOR_CODE = 'login.two-factor.code',
  LOGIN_TWO_FACTOR_EMAIL_LINK_SEND = 'login.two-factor.email.link-send',
  LOGIN_TWO_FACTOR_EMAIL_SEND_FAILED = 'login.two-factor.email.send-failed',
  LOGIN_PROVIDER = 'login.provider',
  LOGIN_TWO_FACTOR_EMAIL = 'login.two-factor.email',
  LOGIN_GRACE_LOGIN = 'login.grace',

  TWO_FA_INDEX = 'two-factor.index',

  RESET_PASSWORD_INDEX = 'reset-password.index',
  RESET_PASSWORD_FORGOT = 'reset-password.forgot',

  BACKUP_INDEX = 'backup.index',

  PROJECT_LOGIN_INDEX = 'project-login.index',

  EXPIRED_LINK = 'expired-link.index',

  VERIFY_ACTION_INDEX = 'verify-action.index',

  INVITATION_ACCEPT = 'invitation.accept',

  BUILDER_INDEX = 'signpost.index',
}
